module.exports = __webpack_public_path__ + "static/media/space-shuttle.2721b653.svg";